import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { ClientReportService } from '../../../service/client-report/client-report.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: 'wa9105.component.html',
  styleUrls: ['wa9105.component.css']
})
export class Wa9105Component implements OnInit {
  public componentTitle = 'WA9105:商品マスタ・商品ラベル選択';
  public updprogramCd = 'WA9105';

  public working = false;
  public height = 500;
  public production = environment.production;
  public backgroundColor: string;

  public printnumNr: FormControl;
  public printTypeCd;
  public printNumTypeCd;
  private selectIds: object[];
  private errorInfo = '';

  constructor(private router: Router, private clientReportService: ClientReportService, private commonService: CommonService, private dialogsService: DialogsService) {
    this.printnumNr = new FormControl(1, [Validators.pattern(/[^0]/), Validators.pattern(/^([+]?)([0-9]*)$/)]);
    this.height = window.innerHeight - 80;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  ngOnInit(): void {
    this.selectIds = JSON.parse(sessionStorage.getItem('wa9100-itemId-itemLabel'));
  }

  onResize(event) {
    this.height = event.target.innerHeight - 80;
  }

  onSubmit() {
    let error = false;
    if (this.printnumNr.errors !== null) {
      this.printnumNr.markAsTouched({ onlySelf: true });
      error = true;
    }
    if (error) {
      return;
    }
    this.working = true;
    let ownerId = 0;
    let reportCd = '';
    switch (this.printTypeCd) {
      case '1':
        reportCd = 'RA9021';
        break;
      case '2':
        reportCd = 'RA9022';
        break;
      case '3':
        reportCd = 'RA9023';
        break;
      case '4':
        reportCd = 'RA9024';
        break;
      default:
        this.working = false;
        this.errorInfo = '予期せぬエラー：未定義の出力内容です';
        return;
    }
    // 商品マスタから出力する場合は、枚数を指定するので、印刷種別は空欄とすること
    this.printNumTypeCd = '';
    this.clientReportService
      .post2(ownerId, reportCd, '', this.printnumNr.value, this.printNumTypeCd, this.updprogramCd, this.selectIds)
      .then(outputJson => {
        this.working = false;
        sessionStorage.removeItem('wa9100-itemId-itemLabel');
        this.router.navigate(['wa9100']);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9105/wa9105.component.ts